import { render, staticRenderFns } from "./InsurancePolicy.vue?vue&type=template&id=57717eec&scoped=true"
import script from "./InsurancePolicy.vue?vue&type=script&lang=js"
export * from "./InsurancePolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57717eec",
  null
  
)

export default component.exports